import React, { memo, useEffect, useRef } from 'react'
import { useI18n } from '@/hooks/useLocale'
import { CommonForm } from '..'
import { Button, Grid, Input } from '@arco-design/web-react'
import { IconDown, IconSearch, IconUp } from '@arco-design/web-react/icon'
import { useMountedState } from '@/hooks/useMountedState'
const Row = Grid.Row
const Col = Grid.Col

const _SearchPanel = ({
  onQuery,
  className,
  searchItem,
  initData,
  newFormData,
  onChange,
  canSearch,
  tools,
  toolWidth,
  showSearchButton,
  toolsSlotName,
  sizeClass = 'small',
  style,
  labelCol,
  wrapperCol,
  simpleSearch,
  setShowKeyword,
  showKeyword,
  keyword,
  setKeyword,
  event,
  simpleSearchInputWidth = '200px', //简单查询输入框width,
  searchContentFlex,
  searchPlaceholder,
  simpleSearchProps = {}, //简单查询props
  searchFlex,
}) => {
  const t = useI18n()
  const isMounted = useMountedState()
  const formRef = useRef(null)
  const col = {
    style: { width: '220px', marginRight: '8px' },
    labelCol: { flex: '100px' },
    wrapperCol: { flex: 'auto' },
  }
  if (searchItem) {
    for (let index = 0; index < searchItem.length; index++) {
      const item = searchItem[index]
      if (!item.style) item.style = col.style
      if (!item.labelCol) item.labelCol = col.labelCol
      if (!item.wrapperCol) item.wrapperCol = col.wrapperCol
    }
  }
  const resetForm = () => {
    if (formRef && formRef.current) {
      formRef.current.resetForm()
    }
  }
  useEffect(() => {
    if (!isMounted()) return
    if (event) {
      switch (event.name) {
        case 'resetForm':
          resetForm()
          break
        default:
          break
      }
    }
  }, [event])
  const renderForm = () => {
    return (
      <CommonForm
        ref={formRef}
        initData={initData}
        newFormData={newFormData}
        formItem={searchItem}
        layout="inline"
        sizeClass={sizeClass}
        style={style}
        onChange={(newData, oldData, fieldName) => {
          onChange && onChange(newData, oldData, fieldName)
        }}
        labelCol={labelCol}
        wrapperCol={wrapperCol}
      />
    )
  }

  const complexQuery = !showKeyword && searchItem && (
    <div
      className={simpleSearch ? 'complex-query' : 'complex-simpleSearch'}
      style={{ display: !simpleSearch ? 'flex' : undefined }}
    >
      {renderForm()}
      {showSearchButton && renderForm() && (
        <div>
          <Button
            type="primary"
            size={sizeClass}
            icon={<IconSearch />}
            onClick={() => onQuery(2)}
          >
            {t('b_query')}
          </Button>
        </div>
      )}
    </div>
  )
  const searchContent = (canSearch === undefined || canSearch === true) && (
    <div>
      {!simpleSearch && complexQuery}
      {simpleSearch && (
        <div style={{ display: 'flex', padding: '0', alignItems: 'center' }}>
          {simpleSearchProps?.label}
          {
            <Input
              size={sizeClass || 'small'}
              style={{ width: simpleSearchInputWidth }}
              placeholder={searchPlaceholder ?? t('t_keyword')}
              value={keyword}
              onChange={(value, e) => {
                setKeyword(value?.trim() ?? value)
              }}
              allowClear={true}
              suffix={<IconSearch />}
              disabled={false}
              onPressEnter={(e) => {
                onQuery(1)
              }}
              {...simpleSearchProps}
            />
          }
          <div
            style={{ width: '80px', paddingLeft: '8px', paddingLeft: '16px' }}
          >
            <Button
              type="primary"
              size={sizeClass}
              icon={<IconSearch />}
              onClick={() => onQuery(1)}
            >
              {t('b_query')}
            </Button>
          </div>
          <div style={{ display: 'flex', padding: '0' }}>
            {searchItem && (
              <Button
                type="text"
                size={sizeClass}
                onClick={() => {
                  setShowKeyword(!showKeyword)
                }}
              >
                {t('b_complexQuery')}
                {showKeyword ? <IconDown /> : <IconUp />}
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  )
  return (
    <div className={className}>
      {toolsSlotName && searchContent}
      {!toolsSlotName && (
        <div>
          <Row style={{ flexFlow: 'row' }}>
            <Col flex={searchContentFlex ? searchContentFlex : 'auto'}>
              {searchContent}
            </Col>
            <Col
              flex={
                searchFlex
                  ? searchFlex
                  : (toolWidth ? toolWidth : tools ? 200 : 0) + 'px'
              }
            >
              {tools}
            </Col>
          </Row>
          {simpleSearch && complexQuery}
        </div>
      )}
    </div>
  )
}

export const SearchPanel = memo(_SearchPanel)

